/**
 * @shared/commerce - the customer side of buying (wallet, canteen, orders), one design for the
 * Parent app now and the Student app later (owner, 19 Oct 2026). The Employee app (Flutter) mirrors
 * the same tokens. See Mobile/Shared/README.md for how an app wires the @shared alias.
 */
// Not './tokens': Metro resolves .json before .ts, so that would load tokens.json itself.
export * from './commerceTokens';
export * from './components';
export { Gradient } from './Gradient';
